export const DataCenters = Object.freeze({
    DATA_CENTER_CARACAS: {
        id: 1,
        name: 'Data Center Caracas',
        location: 'Caracas',
        shortLocation: 'CCS',
        alias: 'CTDC',
    },
    DATA_CENTER_VALENCIA: {
        id: 2,
        name: 'Data Center Valencia',
        location: 'Valencia',
        shortLocation: 'VAL',
        alias: 'CTDV',
    },
});

export const Parameters = Object.freeze({
    TEMPERATURE: {
        id: 1,
    },
    HUMIDITY: {
        id: 2,
    },
});

export const Resources = Object.freeze({
    CONTACTS: {
        id: 1,
        name: 'Contacts',
    },
    FEEDBACKS: {
        id: 2,
        name: 'Feedbacks',
    },
    FINANCES: {
        id: 3,
        name: 'Finanzas',
    },
    REPORTS: {
        id: 4,
        name: 'Reports',
    },
    ROLES: {
        id: 5,
        name: 'Roles',
    },
    TICKETS: {
        id: 6,
        name: 'Tickets',
    },
    EQUIPMENTS: {
        id: 7,
        name: 'Equipments',
    },
    CUSTOMERS: {
        id: 8,
        name: 'Customers',
    },
    PDT: {
        id: 9,
        name: 'PDT',
    },
    HEALTH_REPORTS: {
        id: 10,
        name: 'Health Reports',
    },
    ACTIVE_DIRECTORY_GROUPS: {
        id: 11,
        name: 'ADGroups',
    },
    CUSTOMER_CONTACTS: {
        id: 12,
        name: 'Customer Contacts',
    },
    REMOTE_HANDS: {
        id: 13,
        name: 'Asistencia remota',
    },
    EQUIPMENT_MOVEMENT: {
        id: 14,
        name: 'Movimiento de equipo',
    },
    PRIVILEGE_ADMINISTRATION: {
        id: 15,
        name: 'Control de privilegios',
    },
    PRIVILEGE_INFODAYCO: {
        id: 16,
        name: 'INFODAYCO',
    },
    PRIVILEGE_REPORT_MANAGEMENT: {
        id: 17,
        name: 'Reports Management',
    },
});

export const Actions = Object.freeze({
    CREATE: {
        id: 1,
        name: 'create',
    },
    READ: {
        id: 2,
        name: 'read',
    },
    UPDATE: {
        id: 3,
        name: 'update',
    },
    DELETE: {
        id: 4,
        name: 'delete',
    },
});

export const Daycohost = Object.freeze({
    id: 21347,
    name: 'Dayco Telecom C.A.',
});

export const Tickets = Object.freeze({
    ACCESS: {
        id: 7,
        name: 'Acceso',
        alias: 'access',
        typings: {
            first_access_typing: 7564,
            second_access_typing: 7567,
        },
    },
    INCIDENT: {
        id: 2,
    },
    REMOTE_ASSISTANCE: {
        alias: 'remote-assistance',
        id: 2146,
    },
    TAPE_MANAGEMENT: {
        alias: 'tape-management',
    },
    REQUIREMENT: {
        id: 1,
        name: 'Requerimiento',
        typings: {
            tapeChange: {
                id: 14070,
            },
        },
    },
    ManagementAndManagedServices: {
        name: 'management-and-managed-services',
    },
    NetworkSecurityAndInternet: {
        name: 'network-security-and-internet',
    },
    LinkManagement: {
        name: 'link-management',
    },
    NetworkSecurityAndInternetIncident: {
        name: 'network-security-and-internet-incident',
    },
    ProcessingAndManagedManagement: {
        name: 'processing-and-managed-management',
    },
});

export const WorkflowStates = Object.freeze({
    APPROVE: {
        id: 1,
    },
    REJECT: {
        id: 2,
    },
    REQUEST_CHANGES: {
        id: 3,
    },
});

export const WorkflowActions = Object.freeze({
    APPROVE: {
        id: 2,
    },
    REQUEST_CHANGES: {
        id: 3,
    },
});

export const Statuses = Object.freeze({
    SENT: {
        id: 7,
        name: 'Enviado',
        icon: 'mdi-send',
        color: '#0154A6',
    },
    IN_REVIEW: {
        id: 8,
        name: 'En revisión',
        icon: 'mdi-text-box-search-outline',
        color: '#F9A31B',
    },
    AWAITING_MODIFICATION: {
        id: 9,
        name: 'En espera de modificación',
        icon: 'mdi-pencil-outline',
        color: '#F26935',
    },
    PREAPPROVED: {
        id: 10,
        name: 'Preaprobado',
        icon: 'mdi-comment-check-outline',
        color: '#00AEEF',
    },
    APPROVED: {
        id: 11,
        name: 'Aprobado',
        icon: 'mdi-check',
        color: '#60BB46',
    },
    NOT_APPROVED: {
        id: 12,
        name: 'No Aprobado',
        icon: 'mdi-window-close',
        color: 'red',
    },
});

export const ContactTypes = Object.freeze({
    RESPONSIBLE: {
        id: 1,
        name: 'Responsable',
    },
    AUTHORIZED: {
        id: 2,
    },
    APPLICANT: {
        id: 3,
        name: 'Solicitante',
    },
});

export const AccessMotives = Object.freeze({
    ANOTHER_MOTIVE: {
        id: 20,
    },
});

export const TicketType = {
    ACCESS: 'access',
    TAPE: 'tape-management',
    ASSISTANCE: 'remote-assistance',
    CONTACT: 'contact',
};

export const TapeChangeType = {
    GIVE: {
        id: 1,
        name: 'Entrega',
    },
    TAKE: {
        id: 2,
        name: 'Recibe',
    },
};

export const TicketStatus = {
    OPENED: 'Abierto',
    CLOSED: 'Cerrado',
    FIXED: 'Solucionado',
};

export const ContactManagementType = {
    CREATE: 'create',
    CREATE_USER: 'create-user',
    DELETE: 'delete',
    UPDATE: 'update',
    UPDATE_PROFILE: 'update-profile',
};

export const MovementType = {
    DEPARTURE: 2,
};

export const ContactStatus = {
    PENDING: 'Pendiente',
};

export const ResultStatus = {
    SUCCESS: 'success',
    ERROR: 'error',
};

export const FormView = {
    CREATING: 'creating',
    UPDATING: 'updating',
    CREATING_USER: 'creating user',
    UPDATING_WITHOUT_USER: 'updating without user',
};

export const ContactValidation = {
    EXISTING_EMAIL_AND_CI_IN_CUSTOMER: 'EXISTING_EMAIL_AND_CI_IN_CUSTOMER',
    EXISTING_EMAIL: 'EXISTING_EMAIL',
    EXISTING_CI_IN_CUSTOMER: 'EXISTING_CI_IN_CUSTOMER',
    EXISTING_CI_IN_ANOTHER_CUSTOMER: 'EXISTING_CI_IN_ANOTHER_CUSTOMER',
    CONTACT_NOT_FOUND: 'CONTACT_NOT_FOUND',
    UNDEFINED_ERROR: 'UNDEFINED_ERROR',
};

export const ReportsTypes = {
    MAINTENANCE_REPORT: {
        id: 1,
        name: 'Mantenimiento',
    },
    HEALTH_REPORTS: {
        id: 2,
        name: 'Salud y Gestión',
    },
};

export const DCLocations = {
    CARACAS: {
        name: 'CTDC',
        value: 'CARACAS',
    },
    VALENCIA: {
        name: 'CTDV',
        value: 'VALENCIA',
    },
};
